import React from "react";

const CommentIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 25">
      <g fill="none" transform="translate(3.6 4.6)">
        <path
          stroke="#2B2B2E"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8.4-.75c2.527 0 4.814 1.024 6.47 2.68 1.656 1.656 2.68 3.943 2.68 6.47 0 2.527-1.024 4.814-2.68 6.47-1.656 1.656-3.943 2.68-6.47 2.68-1.749 0-3.383-.49-4.773-1.342-1.018.32-3.143 1.065-3.143 1.065s-.719.253-1.516.54c.302-.792.564-1.505.564-1.505s.753-2.054 1.082-3.1C-.251 11.81-.75 10.164-.75 8.4c0-2.527 1.024-4.814 2.68-6.47C3.586.274 5.873-.75 8.4-.75z"
        ></path>
        <ellipse
          cx="11.865"
          cy="8.54"
          fill="#2B2B2E"
          rx="1.061"
          ry="1.073"
        ></ellipse>
        <ellipse
          cx="8.329"
          cy="8.54"
          fill="#2B2B2E"
          rx="1.061"
          ry="1.073"
        ></ellipse>
        <ellipse
          cx="4.794"
          cy="8.54"
          fill="#2B2B2E"
          rx="1.061"
          ry="1.073"
        ></ellipse>
      </g>
    </svg>
  );
};

export default CommentIcon;
